/**
 * 常用于取消、重置、返回等按钮
 * 默认样式：宽度100%、高度30px
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { Button } from 'antd';

class CancelButton extends React.Component {
    render() {
        const { style, label, ...otherProps } = this.props;
        return (
            <div className={styles.container} style={style}>
                <Button {...otherProps}>{label}</Button>
            </div>
        );
    }
}

CancelButton.propTypes = {
    style: PropTypes.object, // 按钮父级DIV样式
    label: PropTypes.string, // 按钮名称
};

export default CancelButton;